'use client'

import NextLink from 'next/link'
import { useRouter as useNextRouter } from 'next/navigation'
import { forwardRef, type ComponentProps } from 'react'
import { useProgressLink, useProgressRouter } from './useProgressNavigation'

export const Link = forwardRef<HTMLAnchorElement, ComponentProps<typeof NextLink>>(function Link(props, ref) {
  const onClick = useProgressLink(props)
  return <NextLink {...props} ref={ref} onClick={onClick} />
})

/** CMS calls to action may be internal routes, external URLs, or downloads. */
export const Anchor = forwardRef<HTMLAnchorElement, ComponentProps<'a'>>(function Anchor(props, ref) {
  const onClick = useProgressLink(props)
  return <a {...props} ref={ref} onClick={onClick} />
})

export function useRouter() {
  return useProgressRouter(useNextRouter())
}
